// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Recebimentos_SalvarParcelasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /recebimentos/salvar_parcelas — os ids das parcelas da venda, na
 * ordem das parcelas (chamado 2026-0067).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Recebimentos_SalvarParcelasResponseDados {
recebimento_ids: number[]
}

export type Recebimentos_SalvarParcelasResponse = ApiResponse<Recebimentos_SalvarParcelasResponseDados>;

registerResponseContract('Recebimentos_SalvarParcelasResponse', {
  recebimento_ids: { type: 'array',   required: true },
})
